<div class="debug-variables" style="width: 100%; height: 100%; display: grid; grid-template-columns: 1fr 1fr">
  @for (entry of entries(); track $index) {
    <div>{{ entry.variable.name }}</div>
    <div style="font-family: monospace; white-space: pre">
      @if (entry.value === undefined) {
        <i style="opacity: 0.5">NULL</i>
      } @else {
        <span>{{ entry.value }}</span>
      }
    </div>
  }
</div>
